function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { usePrefixCls } from '@byte-design/config';
import { classnames, getUniqueKey } from '@bydesign-ui/utils';
import { useGuid } from '@bydesign-ui/hooks';
import React from 'react';
import { useSorterContainer } from '../../../hooks/sorter';
import { MoveElement } from './MoveElement';
export function SorterContainer(props) {
  var name = props.name,
      className = props.className,
      value = props.value,
      onValueChange = props.onValueChange,
      convertData = props.convertData,
      onDraggingChange = props.onDraggingChange,
      isValidContainer = props.isValidContainer,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'horizontal' : _props$mode,
      children = props.children,
      extra = _objectWithoutProperties(props, ["name", "className", "value", "onValueChange", "convertData", "onDraggingChange", "isValidContainer", "mode", "children"]);

  var _useSorterContainer = useSorterContainer({
    data: value,
    onDraggingChange: onDraggingChange,
    onValueChange: onValueChange,
    convertData: convertData,
    mode: mode,
    isValidContainer: isValidContainer,
    name: name
  }),
      onRemove = _useSorterContainer.onRemove;

  var id = useGuid();
  var cls = classnames(usePrefixCls('sorter-container', {
    mode: mode
  }), className);
  return React.createElement("div", Object.assign({}, extra, {
    className: cls,
    "data-container-id": name
  }), value.map(function (item, index) {
    return React.createElement(MoveElement, {
      data: item,
      key: getUniqueKey(item),
      "data-element-id": id
    }, children(item, function () {
      return onRemove(index);
    }, index));
  }));
}